import { comments } from '@/mocks/home';

export default function Comments() {
  return (
    <section id="comments" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-10">
          用户好评
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 max-w-[1100px] mx-auto">
          {comments.map((c, i) => (
            <div key={i} className="bg-background-50 rounded-xl p-5 md:p-6">
              <div className="flex items-center gap-3 mb-4">
                <img
                  src={c.avatar}
                  alt={c.name}
                  className="w-10 h-10 rounded-full object-cover"
                  loading="lazy"
                />
                <div className="flex-1 min-w-0">
                  <div className="text-sm font-semibold text-foreground-900">{c.name}</div>
                  <div className="text-xs text-foreground-400">{c.time}</div>
                </div>
                <div className="flex items-center gap-1 text-xs text-foreground-400 flex-shrink-0">
                  <i className="ri-thumb-up-line"></i>
                  <span>{c.likes}</span>
                </div>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed">{c.content}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}